export const getTimeByTimezone = (dateObj, timezone = 'fa-IR') => {
  const time = new Date(dateObj).toLocaleTimeString(timezone, {
    hour: '2-digit',
    minute: '2-digit',
  })

  return time
}

const getFullMonthname = (dateObj, timezone) => {
  return dateObj.toLocaleDateString(timezone, {
    month: 'long',
  })
}

const getFullYearNumber = (dateObj, timezone) => {
  return dateObj.toLocaleDateString(timezone, {
    year: 'numeric',
  })
}

const getDayNumber = (dateObj, timezone) => {
  return dateObj.toLocaleDateString(timezone, {
    day: 'numeric',
  })
}

const getFullWeekdayName = (dateObj, timezone) => {
  return dateObj.toLocaleDateString(timezone, {
    weekday: 'long',
  })
}

export const getTimeByTimezoneFull = (dateObj) => {
  const timezone = 'fa-IR'

  const weekday = getFullWeekdayName(dateObj, timezone)
  const dayNumber = getDayNumber(dateObj, timezone)
  const monthName = getFullMonthname(dateObj, timezone)
  const year = getFullYearNumber(dateObj, timezone)

  const fullText = `${weekday} - ${dayNumber} ${monthName} ${year}`

  return fullText
}

/**
 * Checks if two dates are equally in the same day or not
 *
 * @param {Object} dOne - first date
 * @param {Object} dTwo - second date
 */
export const areInTheSameDay = (dOne, dTwo) => {
  const date1 = new Date(dOne)
  const date2 = new Date(dTwo)

  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  )
}
